import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import {
  clearObject,
  getObjectName,
  setObjectDetails,
} from "../../redux/reducers/objectSlice";

const customStyles: any = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#2c2c2c",
    borderColor: "#4a4a4a",
    color: "#ffffff",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#2c2c2c",
    color: "#ffffff",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#ffffff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#4a4a4a" : "#2c2c2c",
    color: "#ffffff",
  }),
  input: (provided) => ({
    ...provided,
    color: "#ffffff",
  }),
  placeholder: (provided) => ({
    ...provided,
    // color: "#ffffff",
  }),
};

const SearchableSingleSelectDropdown = ({ options }) => {
  const objectName = useAppSelector(getObjectName);
  const initialSelectedOption = options.find((x) => x.value === objectName);

  const [selectedOption, setSelectedOption] = useState(initialSelectedOption);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!initialSelectedOption) setSelectedOption(null);
    else setSelectedOption(initialSelectedOption);
  }, [objectName, initialSelectedOption]);

  const handleChange = (option) => {
    setSelectedOption(option);
    dispatch(clearObject());
    dispatch(
      setObjectDetails({
        objectName: option.value,
      })
    );
  };

  return (
    <div>
      <Select
        value={selectedOption}
        onChange={handleChange}
        options={options}
        isSearchable={true}
        placeholder="Select Object"
        styles={customStyles}
      />
    </div>
  );
};

export default SearchableSingleSelectDropdown;
